export default "__VITE_ASSET__a4ec46c3__"